import { Component, ViewChild, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import Swal from 'sweetalert2';

import { environment } from '@teem/environments/environment';

import { ACTIONS as PROPOSAL_ACTIONS } from '@teem/constants/proposal';
import { ProposalService } from '@teem/services/proposal.service';
import { LoaderService } from '@teem/services/loader.service';
import { messages as i18n } from '@teem/constants/messages';
import { UserService } from '@teem/services/user.service';
import { Proposal } from '@teem/models/proposal';


@Component({
  selector: 'edit-proposal',
  templateUrl: './edit-proposal.component.html',
  styles: []
})
export class EditProposalComponent implements OnInit {
  @ViewChild('clientDetailRef') clientDetailRef: any;

  @Input() proposal: Proposal;
  @Output() onEditProposal: EventEmitter<any> = new EventEmitter();

  activeStep: any;;
  steps: any = [
    { key: 'client-detail', data: null, completed: false },
    { key: 'project-detail', data: null, completed: false },
    { key: 'quotes', data: null, completed: false },
    { key: 'terms', data: null, completed: false },
    { key: 'overview', data: null, completed: false }
  ];
  selectedClient: any;
  defaultPaymentInfo: any = {};
  defaultTerms: any;

  constructor(
    private fb: FormBuilder,
    private proposalService: ProposalService,
    private loaderService: LoaderService,
    private userService: UserService) {
  }

  ngOnInit(): void {
    this.userService.getSetting({ key: ['payment_info', 'terms'] }).subscribe((data: any) => {
      this.defaultPaymentInfo = data.payment_info ? data.payment_info : {};
      this.defaultTerms = data.terms ? data.terms : [];
    });

    this.activeStep = this.steps[0];
  }

  onCompleteStep(values: any) {
    if (this.activeStep.key == "client-detail") {
      this.selectedClient = values;
    }
    else if (this.activeStep.key == "quotes" && this.selectedClient.id != values.client.id) {

      // Update client detail form
      this.clientDetailRef.clientId = values.client_id;
      this.clientDetailRef.selectedClient = values.client;

      // Update client step detail
      let index = this.steps.findIndex(step => step.key == "client-detail");
      this.steps[index].data = this.selectedClient = values.client;
    }

    this.activeStep.data = values;
    this.activeStep.completed = true;
    this.nextStep();
  }

  nextStep() {
    let index = this.steps.findIndex(step => step.key == this.activeStep.key);
    this.activeStep = this.steps[index + 1];
  }

  skipStep() {
    this.activeStep.data = null;
    this.activeStep.completed = true;
    this.nextStep();
  }

  previousStep() {
    let index = this.steps.findIndex(step => step.key == this.activeStep.key);
    this.activeStep = this.steps[index - 1];
  }

  goToStep(stepKey: string) {
    let index = this.steps.findIndex(step => step.key == stepKey);

    if (index == 0 || this.steps[index - 1].completed)
      this.activeStep = this.steps[index];
  }

  saveProposal(data: any) {
    let fd = Object.assign({}, data.values);
    fd.is_draft = 0;

    if (data.action == 'draft') {
      fd.action = 'draft';
      fd.is_draft = 1; // save as draft
    } else if (data.action == PROPOSAL_ACTIONS.EMAIL) {
      fd.action = PROPOSAL_ACTIONS.EMAIL;
    } else if (data.action == PROPOSAL_ACTIONS.WHATSAPP) {
      fd.action = PROPOSAL_ACTIONS.WHATSAPP;
    }

    if (!fd.save_default_payment_info)
      delete fd.save_default_payment_info;

    this.loaderService.startLoading();

    fd.uuid = this.proposal.uuid;

    this.proposalService.update(fd, { headers: { 'Content-Type': 'multipart/form-data' } }).subscribe(r => {

      this.loaderService.stopLoading();
      let msg = i18n.proposal.proposal_saved;

      if (fd.action == PROPOSAL_ACTIONS.WHATSAPP) {
        msg = i18n.proposal.proposal_saved_and_whatsapp;
      } else if (fd.action == PROPOSAL_ACTIONS.EMAIL) {
        msg = i18n.proposal.proposal_saved_and_email;
      }

      Swal.fire(i18n.saved, msg, 'success').then(() => {
        this.onEditProposal.emit(data);
      });

      if (data.action == 'pdf' && r.uuid) {
        (window as any).open(`${environment.baseUrl}/download-proposal/${r.uuid}/pdf?lang=${(window as any).LOCALE}`, '_blank');
      }
    }, err => {
      this.loaderService.stopLoading();

      if (err.error && err.error.errors && err.error.errors.proposal_number && err.error.errors.proposal_number[0]) {
        Swal.fire(i18n.alert.error, err.error.errors.proposal_number[0], 'error');
      } else {
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      }

    })

  }
}
